import { httpRequests } from 'investira.sdk';
import { DASHBOARD_POSICAO } from '../const/servicesURI';
import requestService from './requestService';
import utils from '../utils';

const cancel = {
  posicao: null
};

export const posicao = (pParams, pResolve, pReject, pFinally) => {
  if (cancel.posicao) {
    cancel.posicao.cancel();
  }

  cancel.posicao = httpRequests.cancelToken();
  const xNoCacheParams = {
    ...pParams,
    _ts: Date.now()
  };

  const xProps = {
    // Evita reaproveitamento de cache HTTP em uma rota altamente dinamica.
    params: xNoCacheParams,
    cancelToken: cancel.posicao.token
  };

  return requestService(xProps, DASHBOARD_POSICAO, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Dashboard Posição');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      cancel.posicao = null;
      pFinally && pFinally();
    });
};

const dashboard = { posicao, cancel };

export default dashboard;
